import { bindActionCreators, Dispatch } from "redux";
import { connect, RootStateOrAny } from "react-redux";

import { Typography } from "antd";

import { getExpired } from "store/authorization/expired/actions";
import { getCategoryDocsForMemDocPage, getMostRecentDocsForMemDocPage  } from "store/eligibility/documents/actions";
import { getMembersAndCaseDocuments } from "store/eligibility/caseDoc/actions";
import { getGroupsAndCategories } from "store/eligibility/documents/actions";
import { updateReadInfo } from "store/eligibility/pac/actions";
import { getProviderByFileId, getSpecByFileId } from 'store/eligibility/documents/actions';
import { downloadFile } from 'store/authorization/files/actions';

//eligibility info page related
import { SearchCriteria, search } from "store/eligibility/actions";
import { downloadMemberDocument } from "store/eligibility/documents/actions";

import DocumentCards from "components/Documents/CardGroup";

import './index.scss';

const { Title } = Typography;

interface LatestDocumentsPageProps {
  getDownloadResources(filePath: string, companyId: string): any;
  getExpired(userId: string): any,
  getMembersAndCaseDocuments(userId: string): any
  getCategoryDocsForMemDocPage(userId: string, categoryDescArray: string[]): any,
  getMostRecentDocsForMemDocPage(userId: string, pageSize: number): any,
  downloadMemberDocument(memberFilePath: string, memberFileName: string, membMpiNo: string): any,
  getGroupsAndCategories(userId: string): any,
  updateReadInfo(passedUserId: string, passedPacUid: string, passedPacType: string): any,
  getProviderByFileId(fileId: number): any,
  getSpecByFileId(fileId: number): any,
  downloadFile(companyId: string, filePath: string): any,
  isFetchingExpired: boolean,
  isFetchingForMemDoc: boolean,
  isFetchingGroups: boolean,
  isFetching: boolean,
  isFetchingLatestDocuments: boolean,

  //eligibility info page related
  search(searchCriteria: SearchCriteria): any,
}

const LatestDocumentsPage = (props: LatestDocumentsPageProps) => {

  return (
    <div className="documents-page">
      <div className="header-title">
        <Title level={4} className="ml-3">New Documents</Title>
      </div>

      <div className="search-section">
        <DocumentCards
          getCategoryDocsForMemDocPage={props.getCategoryDocsForMemDocPage}
          getMostRecentDocsForMemDocPage={props.getMostRecentDocsForMemDocPage}
          getGroupsAndCategories={props.getGroupsAndCategories}
          search={props.search}
          updateReadInfo={props.updateReadInfo}
          downloadMemberDocument={props.downloadMemberDocument}
          isFetchingExpired={props.isFetchingExpired}
          isFetchingForMemDoc={props.isFetchingForMemDoc}
          isFetchingGroups={props.isFetchingGroups}
          isFetching={props.isFetching}
          isFetchingLatestDocuments={props.isFetchingLatestDocuments}
          getProviderByFileId={props.getProviderByFileId}
          getSpecByFileId={props.getSpecByFileId}
          downloadFile={props.downloadFile}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingExpired: store.rootReducer.authExpired.isFetchingExpired, //open Auth table
  isFetchingForMemDoc: store.rootReducer.eligibilityDocuments.isFetchingForMemDoc, //Rescmind Notice and Member Roster
  isFetching: store.rootReducer.eligibilityCaseDoc.isFetching, // Case Documents
  isFetchingGroups: store.rootReducer.eligibilityDocuments.isFetchingGroups, //fetching all the unread document counts
  isUpdating: store.rootReducer.eligibilityPAC.isUpdating, //Update Read Document
  isFetchingLatestDocuments: store.rootReducer.eligibilityDocuments.isFetchingLatestDocuments, //Get Latest 15 Documents
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getExpired,
    getMembersAndCaseDocuments,
    getCategoryDocsForMemDocPage,
    getGroupsAndCategories,
    downloadMemberDocument,
    updateReadInfo,
    getMostRecentDocsForMemDocPage,
    getProviderByFileId,
    getSpecByFileId,
    downloadFile,

    //eligibility info page related
    search,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(LatestDocumentsPage);
